import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  VrsCallCommentsHarassmentQuestions,
  VrsCallCommentsReasonRadioControl,
  VrsCallCommentsReasonSelectControl,
} from 'features/call/vrs-call-comments/components';
import { AbuseReasonValue } from 'features/call/vrs-call-comments/enums';
import type { VrsCallCommentsAbuseFormControl } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const VrsCallCommentsReasonControl: FC<
  VrsCallCommentsAbuseFormControl
> = ({ control }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText',
  });
  const [selectedValue, setSelectedValue] = useState('');

  return (
    <>
      <Typography variant='subtitle2' color={theme.palette.grey[300]}>
        {t('reasonTitle')}
      </Typography>

      {Object.values(AbuseReasonValue).map((reasonValue: AbuseReasonValue) => (
        <StyledReasonContainer key={reasonValue}>
          <VrsCallCommentsReasonRadioControl
            controlValue={reasonValue}
            selectedValue={selectedValue}
            setSelectedValueHandler={setSelectedValue}
            control={control}
          />
          {selectedValue === reasonValue && (
            <VrsCallCommentsReasonSelectControl
              commentReason={reasonValue}
              control={control}
            />
          )}
        </StyledReasonContainer>
      ))}

      {selectedValue === AbuseReasonValue.HARASSMENT && (
        <VrsCallCommentsHarassmentQuestions control={control} />
      )}
    </>
  );
};

const StyledReasonContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;
